/**
 * 定价参数卡片组件
 * 职责：展示和配置定价相关的所有参数
 */
import React from 'react';
import { Card, Divider } from 'antd';
import { ProductType } from '../../../../utils/fbaFeeData';
import { BasicParameters } from './Parameters/BasicParameters';
import { LogisticsParameters } from './Parameters/LogisticsParameters';
import { RateParameters } from './Parameters/RateParameters';
import { CorePricingParameters } from './Parameters/CorePricingParameters';

interface PricingParametersCardProps {
    form: any;
    categoryFromBasic: string;
    site: string;
    setSite: (site: string) => void;
    exchangeRate: number;
    setExchangeRate: (rate: number) => void;
    purchaseCostCNY: number;
    setPurchaseCostCNY: (cost: number) => void;
    selectedChannelId: string;
    setSelectedChannelId: (id: string) => void;
    channels: any[];
    loading: boolean;
    selectedChannelRateInfo: any;
    chargeableWeight: number;
    shippingCostCNY: number;
    dutyRate: number;
    setDutyRate: (rate: number) => void;
    productType: ProductType;
    setProductType: (type: ProductType) => void;
    referralRate: number;
    setReferralRate: (rate: number) => void;
    returnRate: number;
    setReturnRate: (rate: number) => void;
    otherCostRate: number;
    setOtherCostRate: (rate: number) => void;
    setLastChanged: (changed: 'price' | 'margin') => void;
    fbaFee: number;
    setFbaFee: (fee: number) => void;
    fbaTierName: string;
    isPeakSeason: boolean;
    setIsPeakSeason: (isPeak: boolean) => void;
    currentStorageFee: number;
    storageFee: { jan_sep: number; oct_dec: number };
    volumeWeight: number;
}

export const PricingParametersCard: React.FC<PricingParametersCardProps> = ({
    form,
    categoryFromBasic,
    site,
    setSite,
    exchangeRate,
    setExchangeRate,
    purchaseCostCNY,
    setPurchaseCostCNY,
    selectedChannelId,
    setSelectedChannelId,
    channels,
    loading,
    selectedChannelRateInfo,
    chargeableWeight,
    shippingCostCNY,
    dutyRate,
    setDutyRate,
    productType,
    setProductType,
    referralRate,
    setReferralRate,
    returnRate,
    setReturnRate,
    otherCostRate,
    setOtherCostRate,
    setLastChanged,
    fbaFee,
    setFbaFee,
    fbaTierName,
    isPeakSeason,
    setIsPeakSeason,
    currentStorageFee,
    storageFee,
    volumeWeight,
}) => {
    return (
        <Card size="small" bordered={false} style={{ background: '#fafafa' }}>
            <BasicParameters
                form={form}
                categoryFromBasic={categoryFromBasic}
                site={site}
                setSite={setSite}
                exchangeRate={exchangeRate}
                setExchangeRate={setExchangeRate}
                purchaseCostCNY={purchaseCostCNY}
                setPurchaseCostCNY={setPurchaseCostCNY}
            />

            <LogisticsParameters
                selectedChannelId={selectedChannelId}
                setSelectedChannelId={setSelectedChannelId}
                channels={channels}
                loading={loading}
                selectedChannelRateInfo={selectedChannelRateInfo}
                chargeableWeight={chargeableWeight}
                shippingCostCNY={shippingCostCNY}
                dutyRate={dutyRate}
                setDutyRate={setDutyRate}
                form={form}
            />

            <RateParameters
                productType={productType}
                setProductType={setProductType}
                referralRate={referralRate}
                setReferralRate={setReferralRate}
                returnRate={returnRate}
                setReturnRate={setReturnRate}
                otherCostRate={otherCostRate}
                setOtherCostRate={setOtherCostRate}
                fbaFee={fbaFee}
                setFbaFee={setFbaFee}
                fbaTierName={fbaTierName}
                isPeakSeason={isPeakSeason}
                setIsPeakSeason={setIsPeakSeason}
                currentStorageFee={currentStorageFee}
                storageFee={storageFee}
                volumeWeight={volumeWeight}
                chargeableWeight={chargeableWeight}
            />

            <Divider style={{ margin: '12px 0' }} dashed />

            <CorePricingParameters
                form={form}
                setLastChanged={setLastChanged}
            />
        </Card>
    );
};
